export default __webpack_public_path__ + "static/media/tcd.92e1341e.webm";